import React, { useState } from 'react';
import Child from "./Child";
// import Child from "../search/Child";

export default props=>{
  const [dNotification, setNotification] = useState("none");
  
  if (process.browser) window.unsets.unsetNotification = () => setNotification("none");

  const jsx = (<div className="dib dnom off-svg" >
        <style jsx>{`
span{
	float: left;
}

.off-svg{
  /* vertical-align: mid  dle; */
  vertical-align: top;
  width:24px;
}

.off-svg img{
  float: left;
  padding-top: 8px;
}

`}</style>

    <span className="binder">
      <a className="unsetNotification"><img
        onClick={e =>(dNotification == 'none') ? setNotification("block") : setNotification("none")}
        src="/assets/images/off.svg" 
      /></a>
      <Child dNotification={dNotification} />
    </span>

    </div>);
    return (jsx);
}
